(function () {
  "use strict";

  $(document).ready(function () {
    const videos = document.querySelectorAll(".media-video");

    if (videos.length > 0) {
      let firstVideo = videos[0]; // Seleziona il primo video
      let isHovering = false;

      // Rileva se siamo su mobile
      const isMobile = window.innerWidth <= 768; // Usa breakpoint come riferimento

      if (isMobile) {
        // Usa Intersection Observer per avviare i video solo quando entrano nella viewport su mobile
        if ("IntersectionObserver" in window) {
          const observer = new IntersectionObserver(
            (entries) => {
              entries.forEach((entry) => {
                if (entry.isIntersecting) {
                  entry.target.play(); // Avvia il video quando entra nella viewport
                } else {
                  entry.target.pause(); // Ferma il video quando esce dalla viewport
                }
              });
            },
            { threshold: 0.5 }
          );

          videos.forEach((video) => {
            observer.observe(video); // Usa l'osservatore per ogni video
          });
        }
      } else {
        // Logica normale per desktop
        firstVideo.play();

        function stopOtherVideos(excludeVideo) {
          videos.forEach((video) => {
            if (video !== excludeVideo) {
              video.pause();
            }
          });
        }

        videos.forEach((video, index) => {
          video.addEventListener("mouseenter", function () {
            isHovering = true;
            stopOtherVideos(this);
            this.play();
          });

          video.addEventListener("mouseleave", function () {
            isHovering = false;
            this.pause();

            setTimeout(() => {
              if (!isHovering) {
                firstVideo.play();
              }
            }, 300);
          });
        });
      }
    }
  });
})(jQuery);
